export enum ArticleGridSource {
    Latest = 'latest',
    Standard = 'standard',
}

export const ALL_ARTICLE_GRID_TYPES = Object.values(ArticleGridSource);